/*eslint-disable no-unused-vars */
/*eslint-disable react-hooks/exhaustive-deps*/
import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { Button, Col, Label, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { pick } from 'lodash';

import LocationService from '../../services/Location';

import NumericFormatField from '../../components/NumericFormatField';
import CommonField from '../../components/CommonField';

const FORMULA_TYPE_OPTIONS = [
  { value: 1, label: 'רגיל (קבוע + פעימה)' },
  { value: 2, label: 'לפי ימי עבודה' },
  { value: 3, label: 'מינימום מובטח' },
  { value: 4, label: 'עיגול כלפי מעלה' },
];

const PAYMENT_FREQUENCY_OPTIONS = [
  { value: 1,  label: 'חודשי' },
  { value: 3,  label: 'רבעוני' },
  { value: 6,  label: 'חצי-שנתי' },
  { value: 12, label: 'שנתי' },
];

const PAYMENT_METHOD_OPTIONS = [
  { value: 0, label: 'ללא תשלום' },
  { value: 1, label: 'שיק' },
  { value: 2, label: 'העברה בנקאית' },
  { value: 3, label: 'מזומן' },
];

const WEEK_DAYS_OPTIONS = [
  { value: 0, label: 'ראשון' },
  { value: 1, label: 'שני' },
  { value: 2, label: 'שלישי' },
  { value: 3, label: 'רביעי' },
  { value: 4, label: 'חמישי' },
  { value: 5, label: 'שישי' },
  { value: 6, label: 'שבת' },
];

const MONTHS_OPTIONS = [
  { value: 1, label: 'ינואר' }, { value: 2, label: 'פברואר' },
  { value: 3, label: 'מרץ' },   { value: 4, label: 'אפריל' },
  { value: 5, label: 'מאי' },   { value: 6, label: 'יוני' },
  { value: 7, label: 'יולי' },  { value: 8, label: 'אוגוסט' },
  { value: 9, label: 'ספטמבר' },{ value: 10, label: 'אוקטובר' },
  { value: 11, label: 'נובמבר' },{ value: 12, label: 'דצמבר' },
];

const InitialValues = {
  payperAtt: 0,
  fixedprice: 0,
  casponetpayperAtt: 0,
  casponetfixedprice: 0,
  casponetremarks: '',
  paymentFrequency: 1,
  baseMonths: '',
  paymentMethod: 1,
  paymentFormulaType: 1,
  minPayment: 0,
  roundTo: 0,
  isRateBeforeVAT: false,
  activeWeekDays: '',
};

/* const ValidationSchema = AmountSchema("payperAtt")
  .concat(AmountSchema("fixedprice"))
  .concat(AmountSchema("casponetpayperAtt"))
  .concat(AmountSchema("casponetfixedprice"))
  .shape(); */

const PaymentDetails = ({ formData, getDataFn }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);

  useEffect(() => {
    if (!formData || !formData.id) return;
    const initData = pick(formData, ['id', ...Object.keys(InitialValues)]);
    setFormValues(initData);
  // formData reference changes only when EditLocation fetches new data (after save or mount)
  }, [formData]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(false);

    const payload = {
      ...values,
      payperAtt: parseFloat(values.payperAtt),
      fixedprice: parseFloat(values.fixedprice),
      casponetpayperAtt: parseFloat(values.casponetpayperAtt),
      casponetfixedprice: parseFloat(values.casponetfixedprice),
      paymentFrequency: parseInt(values.paymentFrequency, 10) || 1,
      baseMonths: parseInt(values.paymentFrequency, 10) === 1 ? null : values.baseMonths,
      paymentMethod: parseInt(values.paymentMethod, 10),   // 0 = ללא תשלום, אסור || 1
      paymentFormulaType: parseInt(values.paymentFormulaType, 10) || 1,
      minPayment: parseFloat(values.minPayment) || 0,
      roundTo: parseInt(values.roundTo, 10) || 0,
      isRateBeforeVAT: values.isRateBeforeVAT ? 1 : 0,
      activeWeekDays: values.activeWeekDays || null,
    };

    setIsLoading(true);
    await LocationService.updateLocPayment(payload)
      .then((response) => {
        const { status, message } = response.data;

        if (status === 400) {
          toast.error(message);
          return;
        }

        toast.success(message);
        getDataFn();
      })
      .finally(() => {
        setIsLoading(false);
        setShowEditForm(false);
      });
  };

  const handleShowEditForm = () => {
    setShowEditForm(!showEditForm);
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={{ ...InitialValues, ...formValues }}
        enableReinitialize={true}
        // validationSchema={ValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, isSubmitting, setFieldValue, setFieldTouched }) => (
          <Form id="loc-payment-det" noValidate>
            <Row>
              <Col sm={6} className="border-sep">
                <h4>{t('LOC_PAYMENT.PAY_TO_LOC_INFO')}</h4>
              </Col>

              <Col sm={6} className="d-none d-sm-block">
                <h4>{t('LOC_PAYMENT.PAY_TO_CASP')}</h4>
              </Col>
            </Row>

            <Row>
              {/* Payment to Location Information */}
              <Col sm={6} className="border-sep">
                <Row>
                  {/* Pay Per Attraction */}
                  <Col xs={6}>
                    <div className="mb-3">
                      <NumericFormatField
                        fieldName="payperAtt"
                        fieldValue={values.payperAtt}
                        fieldDecimalScale={2}
                        fieldLabel={t('LOC_PAYMENT.PAY_PER_ATT')}
                        fieldPlaceholder={t('LOC_PAYMENT.PAY_PER_ATT_PLCH')}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        isRequired={false}
                        isDisabled={!showEditForm}
                      />
                    </div>
                  </Col>

                  {/* Fixed Price */}
                  <Col xs={6}>
                    <div className="mb-3">
                      <NumericFormatField
                        fieldName="fixedprice"
                        fieldValue={values.fixedprice}
                        fieldDecimalScale={2}
                        fieldLabel={t('LOC_PAYMENT.FIXED_PRICE')}
                        fieldPlaceholder={t('LOC_PAYMENT.FIXED_PRICE_PLCH')}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        isRequired={false}
                        isDisabled={!showEditForm}
                      />
                    </div>
                  </Col>
                </Row>

                {/* <Row>
                  {/* Modem Number *-/}
                  <Col md={6}>
                    <div className="mb-3">
                      <CommonField
                        fieldName="modemnumber"
                        label="LOC_PAYMENT.MODEM_NO"
                        placeholder="LOC_PAYMENT.MODEM_NO_PLCH"
                      />
                    </div>
                  </Col>
                </Row> */}

                {/* סוג נוסחת תשלום */}
                <Row>
                  <Col xs={6}>
                    <div className="mb-3">
                      <Label>נוסחת תשלום</Label>
                      <Field
                        as="select"
                        name="paymentFormulaType"
                        className="form-select"
                        disabled={!showEditForm}
                      >
                        {FORMULA_TYPE_OPTIONS.map(o => (
                          <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                      </Field>
                    </div>
                  </Col>
                  <Col xs={6} className="d-flex align-items-center pt-2">
                    <div className="form-check mt-3">
                      <Field
                        type="checkbox"
                        name="isRateBeforeVAT"
                        id="isRateBeforeVAT"
                        className="form-check-input"
                        disabled={!showEditForm}
                      />
                      <label className="form-check-label" htmlFor="isRateBeforeVAT">
                        הסכומים לפני מע"מ
                      </label>
                    </div>
                  </Col>
                </Row>

                {/* שדות קונדיציונליים לפי נוסחה */}
                {parseInt(values.paymentFormulaType) === 2 && (
                  <Row>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label>ימים פעילים (יתווסף תשלום יומי אם יש משיכות)</Label>
                        <div className="d-flex flex-wrap gap-2 mt-1">
                          {WEEK_DAYS_OPTIONS.map(day => (
                            <div key={day.value} className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`weekday-${day.value}`}
                                disabled={!showEditForm}
                                checked={(values.activeWeekDays || '').split(',').filter(Boolean).map(Number).includes(day.value)}
                                onChange={e => {
                                  const current = (values.activeWeekDays || '').split(',').filter(Boolean).map(Number);
                                  const updated = e.target.checked
                                    ? [...current, day.value].sort((a, b) => a - b)
                                    : current.filter(v => v !== day.value);
                                  setFieldValue('activeWeekDays', updated.join(','));
                                }}
                              />
                              <label className="form-check-label" htmlFor={`weekday-${day.value}`}>
                                {day.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                {parseInt(values.paymentFormulaType) === 3 && (
                  <Row>
                    <Col xs={6}>
                      <div className="mb-3">
                        <NumericFormatField
                          fieldName="minPayment"
                          fieldValue={values.minPayment}
                          fieldDecimalScale={2}
                          fieldLabel="תשלום מינימלי ₪"
                          fieldPlaceholder="0"
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          isRequired={false}
                          isDisabled={!showEditForm}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
                {parseInt(values.paymentFormulaType) === 4 && (
                  <Row>
                    <Col xs={6}>
                      <div className="mb-3">
                        <NumericFormatField
                          fieldName="roundTo"
                          fieldValue={values.roundTo}
                          fieldDecimalScale={0}
                          fieldLabel="עיגול לכל X ₪"
                          fieldPlaceholder="100"
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          isRequired={false}
                          isDisabled={!showEditForm}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {/* תדירות תשלום + צורת תשלום */}
                <Row>
                  <Col xs={6}>
                    <div className="mb-3">
                      <Label>תדירות תשלום</Label>
                      <Field
                        as="select"
                        name="paymentFrequency"
                        className="form-select"
                        disabled={!showEditForm}
                      >
                        {PAYMENT_FREQUENCY_OPTIONS.map(o => (
                          <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                      </Field>
                    </div>
                  </Col>

                  <Col xs={6}>
                    <div className="mb-3">
                      <Label>צורת תשלום</Label>
                      <Field
                        as="select"
                        name="paymentMethod"
                        className="form-select"
                        disabled={!showEditForm}
                      >
                        {PAYMENT_METHOD_OPTIONS.map(o => (
                          <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                      </Field>
                    </div>
                  </Col>
                </Row>

                {/* חודשי בסיס — מוצג רק אם לא חודשי */}
                {parseInt(values.paymentFrequency) !== 1 && (
                  <Row>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label>חודשי תשלום</Label>
                        <div className="d-flex flex-wrap gap-2">
                          {MONTHS_OPTIONS.map(mo => (
                            <div key={mo.value} className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`month-${mo.value}`}
                                disabled={!showEditForm}
                                checked={(values.baseMonths || '').split(',').map(Number).includes(mo.value)}
                                onChange={e => {
                                  const current = (values.baseMonths || '').split(',').filter(Boolean).map(Number);
                                  const updated = e.target.checked
                                    ? [...current, mo.value].sort((a, b) => a - b)
                                    : current.filter(v => v !== mo.value);
                                  setFieldValue('baseMonths', updated.join(','));
                                }}
                              />
                              <label className="form-check-label" htmlFor={`month-${mo.value}`}>
                                {mo.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}

                <hr className="d-block d-sm-none mt-0" />
              </Col>

              {/* Payment to Casponet */}
              <Col sm={6}>
                <h4 className="d-block d-sm-none">{t('LOC_PAYMENT.PAY_TO_CASP')}</h4>

                <Row>
                  {/* Pay Per Attraction */}
                  <Col xs={6}>
                    <div className="mb-3">
                      <NumericFormatField
                        fieldName="casponetpayperAtt"
                        fieldValue={values.casponetpayperAtt}
                        fieldDecimalScale={2}
                        fieldLabel={t('LOC_PAYMENT.PAY_PER_ATT')}
                        fieldPlaceholder={t('LOC_PAYMENT.PAY_PER_ATT_PLCH')}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        isRequired={false}
                        isDisabled={!showEditForm}
                      />
                    </div>
                  </Col>

                  {/* Fixed Price */}
                  <Col xs={6}>
                    <div className="mb-3">
                      <NumericFormatField
                        fieldName="casponetfixedprice"
                        fieldValue={values.casponetfixedprice}
                        fieldDecimalScale={2}
                        fieldLabel={t('LOC_PAYMENT.FIXED_PRICE')}
                        fieldPlaceholder={t('LOC_PAYMENT.FIXED_PRICE_PLCH')}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        isRequired={false}
                        isDisabled={!showEditForm}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  {/* Remarks */}
                  <Col md={8}>
                    <div className="mb-3">
                      <Label htmlFor="remarksField">{t('EMPLOYEE.REMARKS_LABEL')}</Label>

                      <Field
                        id="remarksField"
                        name="casponetremarks"
                        component="textarea"
                        className="form-control"
                        placeholder={t('EMPLOYEE.REMARKS_PLACEHOLDER')}
                        disabled={!showEditForm}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Submit Button */}
            {showEditForm && (
              <div className="button-items">
                <Button
                  color="primary"
                  className="w-md waves-effect waves-light"
                  type="submit"
                  disabled={isSubmitting || isLoading}
                >
                  {isSubmitting || isLoading ? t('PLEASE_WAIT') : t('SUBMIT')}
                </Button>
                <Button
                  color="light"
                  type="button"
                  onClick={() => {
                    setShowEditForm(false);
                  }}
                >
                  {t('CANCEL')}
                </Button>
              </div>
            )}
          </Form>
        )}
      </Formik>
      {!showEditForm && (
        <div className="button-items">
          <Button
            color="primary"
            className="w-md waves-effect waves-light"
            type="button"
            onClick={handleShowEditForm}
            disabled={isLoading}
          >
            {t('EDIT')}
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};

export default PaymentDetails;
